import { fireNonCancelableEvent, fireCancelableEvent } from '../internal/events/index';
export function useRowEvents(_a) {
    var onRowClick = _a.onRowClick, onRowContextMenu = _a.onRowContextMenu;
    var onRowClickHandler = function (rowIndex, item) {
        var details = { rowIndex: rowIndex, item: item };
        fireNonCancelableEvent(onRowClick, details);
    };
    var onRowContextMenuHandler = function (rowIndex, item, event) {
        var details = {
            rowIndex: rowIndex,
            item: item,
            clientX: event.clientX,
            clientY: event.clientY
        };
        fireCancelableEvent(onRowContextMenu, details, event);
    };
    return {
        onRowClickHandler: onRowClick && onRowClickHandler,
        onRowContextMenuHandler: onRowContextMenu && onRowContextMenuHandler
    };
}
//# sourceMappingURL=use-row-events.js.map